import { ERROR_FETCH_CAMERAS } from '@/utils/messages';
import { toast_error } from '@/libs/toast-wrappers';
import { errorlog } from '@/libs/error-logs';
import { toError } from '@/utils/errors';

import { GET } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

export type CameraOption = Record<string, string>;
type ResponseCameras = { cameras: [] | string };

function formatCamerasOptions(cameras: string | []) {
  const camerasOptionArray: CameraOption[] = [];

  if (typeof cameras === 'string') {
    const camObj: CameraOption = {};
    camObj[cameras] = cameras;
    camerasOptionArray.push(camObj);
  } else {
    for (let cameraIdx = 0; cameraIdx < cameras.length; cameraIdx++) {
      const camObj: CameraOption = {};
      camObj[cameras[cameraIdx]] = cameras[cameraIdx];
      camerasOptionArray.push(camObj);
    }
  }

  return camerasOptionArray;
}

export async function getCamerasByClinic(clinicId: string) {
  try {
    const { cameras } = await GET<ResponseCameras>(ENDPOINTS.CAMERAS_BY_CLINIC, {
      query: { clinicId },
    });
    return formatCamerasOptions(cameras);
  } catch (error) {
    errorlog(error as Error, 'src/api/cameras', 'Error fetching cameras by organization');
    toast_error(ERROR_FETCH_CAMERAS);
    return Promise.reject(toError(error));
  }
}

type CameraBaseResponse = {
  active: boolean;
  camera_manufacturer_model: string;
};

export async function getCameras() {
  try {
    const response = await GET<StandardResponse<CameraBaseResponse[]>>(ENDPOINTS.CAMERAS);
    return response.data.map((camera) => camera.camera_manufacturer_model);
  } catch (error) {
    errorlog(error as Error, 'src/api/cameras', 'Error fetching cameras');
    toast_error(ERROR_FETCH_CAMERAS);
    return Promise.reject(toError(error));
  }
}
